import { render, staticRenderFns } from "./PointBalance.vue?vue&type=template&id=88d93e08&"
import script from "./PointBalance.vue?vue&type=script&lang=js&"
export * from "./PointBalance.vue?vue&type=script&lang=js&"
import style0 from "./PointBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports